module.exports = __webpack_public_path__ + "static/media/noRouteInfoMobile.71631952.svg";